import React from 'react';

import { Typography } from '@material-ui/core';

const CreateSuccess = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Usuário criado com sucesso.
      </Typography>
    </>
  );
};

export default CreateSuccess;
